import { createRequest } from "helpers/tools";

export const createTracker = async (form) => {
    return await createRequest({
        suffix: `tracker-save`,
        method: "post",
        payload: form,
        handleError: false,
    });
};

export const sendFormToService = async (form) => {
    return await createRequest({
        suffix: `send-tracker-instruction`,
        method: "post",
        payload: form,
        handleError: false,
    });
};

export const checkDnsServis = async (form) => {
    return await createRequest({
        suffix: `check-dns`,
        method: "post",
        payload: form,
        handleError: false,
    });
};

export const zohoReconnect = async (id, data) => {
    return await createRequest({
        suffix: `sources/${id}/service-update`,
        method: "post",
        payload: data,
        handleError: false,
    });
};
